@if (splashShowRequest()) {
  <div class="container-splash {{ positionCss() }}">
    <div class="content-img-logo">
      <img [src]="LOGO_SVG" alt="logo" />
    </div>
  </div>
}
